<script>
/* global $ */

export default {
  name: 'SchemeWorkSlider',
  created() {
    $('.scheme__scroll .scheme__items').slick({
      variableWidth: true,
      dots: false,
      infinite: false,
      slidesToScroll: 1,
      slidesToShow: 5,
      swipeToSlide: true,
      speed: 300,
      outerEdgeLimit: true,
      arrows: true,
      prevArrow: $('.arrow_left'),
      nextArrow: $('.arrow_right'),
      responsive: [
        {
          breakpoint: 1050,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 555,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  },
};

</script>

<style lang="scss">
@import './SchemeWorkSlider.scss';
@import '../SlickGallery/SlickGallery.scss';
</style>
